<rt-button
  #addSkillsTrigger="rtOverlayOrigin"
  variant="primary"
  [class.pressed]="overlay().open"
  [loading]="loading()"
  (click)="openOverlay()"
  rt-overlay-origin
>
  <rt-icon name="add" />
  <span>{{
    'tlc.positions.position_details_dialog.tabs.skills.header.add_skills' | translate
  }}</span>
</rt-button>

<ng-template
  [origin]="addSkillsTrigger"
  [rtConnectedOverlayAutoClose]="false"
  (backdropClick)="closeOverlay()"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown [width]="dropdownWidth()">
    <rt-dropdown-item (click)="openChooseSkill($event)">
      <rt-icon prefix name="add" />
      <div class="item-text">
        <span class="item-title">{{
          'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.add_from_library'
            | translate
        }}</span>
        <span class="item-description">{{
          'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.add_from_library_description'
            | translate
        }}</span>
      </div>
    </rt-dropdown-item>
    <rt-dropdown-item (click)="openChooseMapping($event)">
      <rt-icon prefix name="apps" />
      <div class="item-text">
        <span class="item-title">{{
          'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.assign_to_mapping'
            | translate
        }}</span>
        <span class="item-description">{{
          'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.assign_to_mapping_description'
            | translate
        }}</span>
      </div>
    </rt-dropdown-item>
    @if (hasSkillsImportDevFlag()) {
      <rt-dropdown-item (click)="onActionClick(AddSkillsDropdownAction.ImportFromFile)">
        <rt-icon prefix name="file-upload" />
        <div class="item-text">
          <span class="item-title">{{
            'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.import_from_file'
              | translate
          }}</span>
          <span class="item-description">{{
            'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.import_from_file_description'
              | translate
          }}</span>
        </div>
      </rt-dropdown-item>
    }
    <!-- GenerateSuggested is temporarily hidden until the feature is implemented
    <rt-dropdown-item (click)="onActionClick(AddSkillsDropdownAction.GenerateSuggested)">
      <rt-ai-logo class="ai-logo" prefix size="small-x" />
      <div class="item-text">
        <span class="item-title">{{
          'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.generate_suggested'
            | translate
        }}</span>
        <span class="item-description">{{
          'tlc.positions.position_details_dialog.tabs.skills.add_dropdown.generate_suggested_description'
            | translate
        }}</span>
      </div>
    </rt-dropdown-item>
    -->
  </rt-dropdown>
</ng-template>

<ng-template #chooseSkillTpl>
  <rt-dropdown-header>
    <rt-icon-button
      (click)="back()"
      prefix
      variant="plain"
      iconName="keyboard-backspace"
      shape="square"
      size="small"
    />
    <span>{{
      'tlc.positions.position_details_dialog.tabs.skills.choose_skill.title' | translate
    }}</span>
  </rt-dropdown-header>
  <div class="search-container">
    <rt-input
      [placeholder]="'tlc.common.search' | translate"
      [value]="skillSearch()"
      [hasClearButton]="true"
      [autoFocus]="true"
      (valueChange)="skillSearch.set($event)"
    >
      <rt-icon name="search" prefix />
    </rt-input>
  </div>
  <div class="list-container">
    @for (skill of filteredSkills(); track skill.id) {
      <rt-dropdown-item
        [class.item-disabled]="isSkillAssigned(skill.id)"
        [hasHoverEffect]="!isSkillAssigned(skill.id)"
        [hasChevronRight]="!isSkillAssigned(skill.id)"
        (click)="onSkillItemClick(skill, $event)"
      >
        <div class="item-text">
          <span class="item-title">{{ skill.name }}</span>
          @if (isSkillAssigned(skill.id)) {
            <span class="item-description">{{
              'tlc.positions.position_details_dialog.tabs.skills.choose_skill.already_assigned'
                | translate
            }}</span>
          }
        </div>
      </rt-dropdown-item>
    }
  </div>
  <rt-dropdown-item
    [isCreateAction]="true"
    [hasHoverEffect]="true"
    [hasDivider]="true"
    (click)="onActionClick(AddSkillsDropdownAction.CreateNewSkill)"
  >
    <rt-icon prefix name="open-in-new" />
    <span>{{
      'tlc.positions.position_details_dialog.tabs.skills.choose_skill.create_new' | translate
    }}</span>
  </rt-dropdown-item>
</ng-template>

<ng-template #chooseMappingTpl>
  <rt-dropdown-header>
    <rt-icon-button
      (click)="back()"
      prefix
      variant="plain"
      iconName="keyboard-backspace"
      shape="square"
      size="small"
    />
    <span>{{
      'tlc.positions.position_details_dialog.tabs.skills.choose_mapping.title' | translate
    }}</span>
  </rt-dropdown-header>
  <div class="search-container">
    <rt-input
      [placeholder]="'tlc.common.search' | translate"
      [value]="mappingSearch()"
      [autoFocus]="true"
      [hasClearButton]="true"
      (valueChange)="mappingSearch.set($event)"
    >
      <rt-icon name="search" prefix />
    </rt-input>
  </div>
  <div class="list-container">
    @for (mapping of filteredMappings(); track mapping.id) {
      <rt-dropdown-item
        [class.item-disabled]="isMappingAssigned(mapping.id)"
        [hasHoverEffect]="!isMappingAssigned(mapping.id)"
        [hasChevronRight]="!isMappingAssigned(mapping.id)"
        (click)="onMappingItemClick(mapping, $event)"
      >
        <div class="item-text">
          <span class="item-title">{{ mapping.name }}</span>
          <span class="item-description">
            @if (isMappingAssigned(mapping.id)) {
              {{
                'tlc.positions.position_details_dialog.tabs.skills.choose_mapping.already_assigned'
                  | translate
              }}
            } @else {
              {{ resolveSkillsDescription(mapping) }}
            }
          </span>
        </div>
      </rt-dropdown-item>
    }
  </div>
  <rt-dropdown-item
    [isCreateAction]="true"
    [hasHoverEffect]="true"
    [hasDivider]="true"
    (click)="onActionClick(AddSkillsDropdownAction.ManageSkillMappings)"
  >
    <rt-icon prefix name="open-in-new" />
    <span>{{
      'tlc.positions.position_details_dialog.tabs.skills.choose_mapping.manage' | translate
    }}</span>
  </rt-dropdown-item>
</ng-template>

<ng-template #proficiencyTpl>
  <tlc-proficiency-panel
    [skill]="selectedSkill()!"
    [positionName]="positionName()"
    [showBackButton]="true"
    (proficiencySelected)="onSkillSelect($event)"
    (backClick)="back()"
  />
</ng-template>

<ng-template #levelTpl>
  <rt-dropdown-header>
    <rt-icon-button
      (click)="back()"
      prefix
      variant="plain"
      iconName="keyboard-backspace"
      shape="square"
      size="small"
    />
    <span>{{ selectedMapping()?.name }}</span>
  </rt-dropdown-header>
  <span class="panel-subtitle">
    {{
      'tlc.positions.position_details_dialog.tabs.skills.level.subtitle'
        | translate: { positionName: positionName() }
    }}
  </span>
  @for (level of selectedMapping()?.levels; track level.id) {
    <rt-dropdown-item (click)="onMappingLevelSelect(level)" [hasDivider]="true">
      {{ level.name }}
    </rt-dropdown-item>
  }
</ng-template>
